import Player from './Player'

export default Player
// eslint-disable-next-line import/export
export * from './Player'
